import { ENV } from './env';

export const PROJECT_TYPE = {
	PROD: ENV.PROJECT_TYPE === 'PROD',
	STAGE: ENV.PROJECT_TYPE === 'STAGE',
	DEV: ENV.PROJECT_TYPE === 'DEV',
	PREVIEW: ENV.PROJECT_TYPE === 'PREVIEW',
} as const;
